if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalWindow {
    constructor() {
      super();
      this.modalOverlay = this.querySelector('.product-media-modal__content');
      this.closeButton = this.querySelector('.product-media-modal__toggle')

      this._originalParent = this.parentNode;
      this._nextSibling = this.nextElementSibling;

      if (this.modalOverlay) {
        this.modalOverlay.addEventListener('click', (event) => {
          if (
            !event.target.closest('.product-media-modal__wrapper--default') &&
            !event.target.closest('.slider-button') &&
            !event.target.closest('.slider__grid-item') &&
            !event.target.closest('.image-magnify-full-size')
          ) {
            this.hide();
          }
        });
      }
      this.closeButton.addEventListener('click', ()=> this.hide())

    }

    hide() {
      super.hide();

      if (this._originalParent) {
        if (this._nextSibling) {
          this._originalParent.insertBefore(this, this._nextSibling);
        } else {
          this._originalParent.appendChild(this);
        }
      }
    }

    show(opener) {
      document.body.appendChild(this);

      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      /* S4H 17.09.2026: vorher wurde hier bei JEDEM Bild loading="lazy" entfernt -
         beim Oeffnen des Zoom-Fensters luden damit alle Medien des Produkts auf
         einmal (124 Bilder bei der Uni-Krawatte). Jetzt nur das aktive Bild und
         seine Farbgruppe (weiter unten); der Rest laedt beim Blaettern von
         selbst, weil er lazy bleibt. Findet sich keine aktive Kennung, laden
         die ersten drei Bilder sofort, damit das Fenster nie leer aufgeht. */
      const currentMediaId = this.openedBy ? this.openedBy.getAttribute("data-media-id") : null;

      this.querySelectorAll(`[data-media-id]:not([data-media-id="${currentMediaId}"])`).forEach((element) => {
        element.classList.remove('active');
      });

      const activeMedia = currentMediaId ? this.querySelector(`[data-media-id="${currentMediaId}"]`) : null;
      const dataMediaAlt = activeMedia?.dataset.mediaAlt;

      this.querySelectorAll('[data-media-alt]').forEach(element => {
        element.classList.remove('product__media-item--variant--alt');
      });

      if (dataMediaAlt) {
        this.querySelectorAll(`[data-media-alt="${dataMediaAlt}"]`).forEach(element => {
          element.classList.add('product__media-item--variant--alt');
        });
      }

      let geweckt = 0;
      if (activeMedia) {
        this.querySelectorAll(`[data-media-id="${currentMediaId}"] img${dataMediaAlt ? `, [data-media-alt="${dataMediaAlt}"] img` : ''}`).forEach(image => { image.removeAttribute('loading'); geweckt++; });
      }
      if (!geweckt) {
        Array.prototype.slice.call(this.querySelectorAll('img'), 0, 3).forEach(image => image.removeAttribute('loading'));
      }

      const activeMediaTemplate = activeMedia?.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

      activeMedia?.classList.add('active');
      activeMedia?.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      if (container && activeMedia) {
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
      }

      if (
        activeMedia?.nodeName === 'DEFERRED-MEDIA' &&
        activeMediaContent?.querySelector('.js-youtube')
      ) {
        activeMedia.loadContent();
      }

      document.dispatchEvent(new CustomEvent('image:show'));
    }
  });
}